import { render, staticRenderFns } from "./BasicGadget.vue?vue&type=template&id=2dd889ff&scoped=true&"
import script from "./BasicGadget.vue?vue&type=script&lang=ts&"
export * from "./BasicGadget.vue?vue&type=script&lang=ts&"
import style0 from "./BasicGadget.vue?vue&type=style&index=0&id=2dd889ff&lang=scss&scoped=true&"
import style1 from "./BasicGadget.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd889ff",
  null
  
)

export default component.exports